// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  castToString,
  ifEntityGetId,
} from 'helpers/reduxFormFunctions'

const regulatoryDataFormForm = p => {
  const asr = castToString(p.asr)
  const callSign = castToString(p.callSign)
  const licenseBasisId = ifEntityGetId(p.licenseBasis)
  const radioServiceId = ifEntityGetId(p.radioService)
  const stationClassId = ifEntityGetId(p.stationClass)

  return {
    asr,
    callSign,
    licenseBasisId,
    radioServiceId,
    stationClassId,
  }
}

export default regulatoryDataFormForm
